export const SUPPORT_EMAIL = "support@tempo.new";

/**
 * Opens the user's email client with a pre-addressed message to Tempo support.
 * Replaces the previous in-app support chat integration.
 *
 * @param body Optional pre-filled message body (e.g. help context such as the
 *   current canvas/project link).
 */
export function openSupportEmail(body?: string) {
  let url = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Tempo Support")}`;
  if (body) {
    url += `&body=${encodeURIComponent(body)}`;
  }
  window.location.href = url;
}
